import { ReactNode } from "react";
import { Separator } from "@/components/ui/separator";
import { MemberProfileSection } from "@/components/blocks/MemberDetails/MemberProfileSection";
import { ChargeForm } from "@/components/blocks/ChargeMember/ChargeForm";
import { MemberDetailsResponse } from "@/api/members.api";
import { NoPaymentMethodAlert } from "@/components/core/NoPaymentMethodAlert";

interface ChargeFormStepProps {
  memberDetails: MemberDetailsResponse;
  memberId: string;
  onSubmit: (data: any) => void;
  isLoading: boolean;
}

export function ChargeFormStep({
  memberDetails,
  memberId,
  onSubmit,
  isLoading,
}: ChargeFormStepProps): ReactNode {
  const hasPaymentMethod = memberDetails.member.hasPaymentMethod;

  return (
    <>
      <MemberProfileSection memberDetails={memberDetails} />
      <Separator />
      
      {!hasPaymentMethod ? (
        <NoPaymentMethodAlert className="mt-4" />
      ) : (
        <ChargeForm
          memberId={memberId}
          currency={memberDetails.currency} 
          onSubmit={onSubmit}
          isLoading={isLoading}
        />
      )}
    </>
  );
} 